import type { TOC } from '@ember/component/template-only'
import { t } from 'ember-intl'
import {
  InlineAlert,
  AlertType,
  InlineAlertSubtitle,
  InlineAlertTitle,
} from 'teacher-ui-client/components/inline-alert'

interface Signature {
  Element: HTMLDivElement
  Args: {
    show: boolean
  }
}
export const UnknownErrorAlert: TOC<Signature> = <template>
  {{#if @show}}
    <InlineAlert data-test-unknown-error-alert @type={{AlertType.Critical}} ...attributes>
      <InlineAlertTitle>
        {{t "components.copyClasses.unknownError.problem"}}
      </InlineAlertTitle>
      <InlineAlertSubtitle>
        {{t "components.copyClasses.unknownError.solution"}}
      </InlineAlertSubtitle>
    </InlineAlert>
  {{/if}}
</template>
